import { Inject } from 'vue-di-container';
import { Component, Vue } from 'vue-property-decorator';

import WithRender from './preview-contract.component.html';
import { EventBus, Events } from '@/event-bus';
import CancelRequestComponent from '@/components/dialog/cancel-request.component.vue';
import OtpComponent from '@/components/OTP/OtpComponent.vue';
import { ClauseTypeEnum } from '@/enums/ClauseTypeEnum';
import { TarafTypeEnum } from '@/enums/tarafTypeEnum';
import { OTPRefrenceDataModel } from '@/models/OTPRefrenceDataModel';
import { Result } from '@/models/Result';
import { CreateContractModel } from '@/models/contractDetailsModel';
import UserModel from '@/models/user';
import router from '@/router';
import ExternalService from '@/services/external';
import { Toaster } from '@/services/toast';
import UserService from '@/services/user';
import { moduleProxy } from '@/store';
import ContractService from '@/services/contract.service';
import { ContractClausesModel } from '@/models/contractClausesModel';

@WithRender
@Component({
  components: { OtpComponent },
  diProvide: [
    ContractService,
    UserService,
    ExternalService,
  ],
})
export default class PreviewContract extends Vue {
  @Inject(ContractService) public contractService!: ContractService;
  @Inject(UserService) public userService!: UserService;
  @Inject(ExternalService) public externalService!: ExternalService;
  otpData: Result<OTPRefrenceDataModel> = {} as Result<OTPRefrenceDataModel>;
  contractModel: CreateContractModel = {} as CreateContractModel;
  clausesText: ContractClausesModel[] = [];
  currentUser = {} as UserModel;
  tarafTypeEnum = TarafTypeEnum;

  created() {
    // Subscribe to an event.
    EventBus.$on(Events.Request.ConfirmCancelRequestEvent, () => {
      moduleProxy.Contract.clearContract();
      this.$router.push({ name: 'issueContract' });
    });
  }

  mounted() {
    const contract = moduleProxy.Contract.getContract;
    if (contract?.clauses && contract?.clauses?.length > 0) {
      this.contractModel = JSON.parse(JSON.stringify(contract));
      this.clausesText = moduleProxy.Contract.getClausesText.filter((x) => x.clauseTypeId === ClauseTypeEnum.Clause);
    }

    this.getCurrentUser();
  }

  beforeDestroy() {
    // Unsubscribe from an event.
    EventBus.$off(Events.Request.ConfirmCancelRequestEvent);
  }

  previousStep() {
    router.push({ name: 'contractData' });
  }

  async onSubmitContract(): Promise<void> {
    await (this.$refs.otp as any).sendOtp();
  }

  async submitContract(otpData: OTPRefrenceDataModel): Promise<void> {
    if (!otpData) return;

    this.contractModel.oTPRefrenceDataDTO = otpData;

    console.debug('Preview contract -> submit contract', this.contractModel);

    const result = await this.contractService.submitContract(this.contractModel);

    if (result.statusCode === 200) {
      router.push({ name: 'userContracts' }).then(() => {
        moduleProxy.mainAlert.show({ template: `<div class="font-weight-bold" style="font-size: 1.5rem;">تم إرسال طلب توثيق عقد بنجاح</div><div class="text-dark text-sm">رقم الطلب: ${result.model.requestCode}</div>` });
      });
    } else {
      Toaster.error({ message: result.errorMessage });
    }
  }

  getCurrentUser() {
    this.userService.getUser().then((response) => {
      this.currentUser = response;
    });
  }

  /**
   * Initiate cancel request process.
   */
  onCancel(): void {
    // Publish an event.
    EventBus.$emit(Events.Dialog.OpenDialogEvent, CancelRequestComponent);
  }
}
